import React from "react";
import BookingFeedback from './BookingFeedback';
import { Alert } from "react-bootstrap";
import parse from 'html-react-parser';

export default ({
  loadAlert,
  variant,
  text,
  className = "",
  disabled = false,
  ...props
}) => {
  let feedback = null;
  if (variant === 'success') {
    feedback = <BookingFeedback id={props.id}></BookingFeedback>;
  }

  return (
    <div>
      <Alert
        variant={variant}
        className={`AlertDiv ${loadAlert ? 'alert-shown' : 'alert-hidden'}`}
        disabled={disabled || loadAlert}
        {...props}
      >
        {parse(text)}
      </Alert>
      {feedback}

    </div>
  );
}

